<template>
    <v-card elevation="6" class="base-card-container pa-5 mt-4">
        <v-row>
            <!-- TODO: MAKE THE ABOVE collapse A COMPONENT AN PASS THE V-IF PROPERTY -->
            <v-col cols="12" v-if="isRobo == true">
                <v-card>
                    <v-card color="primary">
                        <v-card-title class="card-title-text">Robo</v-card-title>
                    </v-card>
                    <v-container class="pt-5 px-4 pb-0">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-checkbox class="ma-0 pb-0" v-model="checkFist" disabled>
                                    <template v-slot:label>
                                        <span class="label-text">Inicio de denuncia o carpeta</span>
                                    </template></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-checkbox v-if="checkSecond" class="ma-0 pb-0" v-model="checkSecond"
                                    :disabled="checkSecond">

                                    <template v-slot:label>
                                        <span class="label-text">Liberación vehículo robado</span>
                                    </template></v-checkbox>
                                <div v-if="!checkSecond">
                                    <v-btn outlined x-small v-on:click="libVehRobo()" color="red" class="classcheck"
                                        :disabled="disabledcheckdos">
                                    </v-btn>
                                    <span class="label-text ml-2">Liberación vehículo robado</span>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <div v-if="loaded != true">
            <v-col cols="12" class="py-4">
                <center>
                    <v-progress-circular indeterminate :size="68" :width="6" color="grey"></v-progress-circular>
                </center>
            </v-col>
        </div>
        <div v-if="loaded == true" class="px-3 my-5">
            <v-row v-if="initialDataArray.length == 2 &&
                initialDataArray[0].aspartenomb != 'Liberación de Vehículo'
                " class="my-4">
                <v-row>
                    <!-- TODO:  -->
                    <v-col cols="12" md="6" v-for="(item, index) in initialDataArray" :key="index">
                        <checkBoxesCard :class="finalCanInsertMoves[index] == true ? '' : 'noClickEvent'"
                            v-if="mostrarLibFisica[index] != false" style="height: 100% !important"
                            :cardTitle="item.aspartenomb" :checkBoxesInfo="mainResponseArray[index]" subTitlesData=""
                            :extraDataInfo="extraDataResponseArray[index]" :fatherColumSize="12" :showDisposicion="item"
                            :valueDisposicion="valorDispocision" :canInsertMoves="canInsertMoves"
                            :reporteInfo="reporteInfoArray[index]" :canOnlyInsertQuerella="canInserOnlyQuerrella"
                            :esPrestacionEspe='esPrestacionEspe'>
                        </checkBoxesCard>
                    </v-col>
                </v-row>
            </v-row>

            <v-row v-if="initialDataArray.length != 2 ||
                initialDataArray[0].aspartenomb == 'Liberación de Vehículo'
                ">
                <v-row>
                    <!-- TODO:  -->
                    <v-col cols="12" md="6" v-for="(item, index) in initialDataArray" :key="index">

                        <template v-if="mostrarLibFisica[index] != false">
                            <checkBoxesCard :class="finalCanInsertMoves[index] == true ? '' : 'noClickEvent'"
                                style="height: 100% !important" :cardTitle="item.aspartenomb"
                                :checkBoxesInfo="mainResponseArray[index]" subTitlesData=""
                                :extraDataInfo="extraDataResponseArray[index]" :fatherColumSize="12"
                                :showDisposicion="item" :valueDisposicion="valorDispocision"
                                :canInsertMoves="canInsertMoves" :reporteInfo="reporteInfoArray[index]"
                                :canOnlyInsertQuerella="canInserOnlyQuerrella" :esPrestacionEspe='esPrestacionEspe'>
                            </checkBoxesCard>
                        </template>
                    </v-col>
                </v-row>
            </v-row>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <tramitesButtons :tramitesOptions="tramitesOptions" @reload="reload"></tramitesButtons>
            </v-col>
        </v-row>

        <!--Movimientos-->
        <v-row>
            <v-col cols="12" md="12">
                <Movimientos @reload="reload"></Movimientos>
            </v-col>
        </v-row>

        <v-dialog transition="dialog-top-transition" max-width="600" v-model="libVehDialog" persistent>

            <template>
                <v-card>
                    <v-toolbar color="#ef6c00" dark>
                        <v-toolbar-title>Detener Vehículo</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                            <v-icon @click="
                (libVehDialog = false), (checkSecond = false), resetForm()
                ">mdi-close-box</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-form v-model="validForm" ref="form">
                            <v-row class="mt-4">
                                <v-col cols="12" md="12">
                                    <v-text-field label="Firma electronica:" v-model="efirma" filled
                                        :rules="efirmaRules" type="password"
                                        :error-messages="eFirmaErrormessage"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <span> Estuvo a disposición de la autoridad </span>
                                    <v-radio-group v-model="disposicionAutoridadCheck" row
                                        :rules="disposicionAutoridadRules">
                                        <v-radio label="SI" :value="true"></v-radio>
                                        <v-radio label="NO" :value="false"></v-radio>
                                    </v-radio-group>

                                    <div v-if="disposicionAutoridadCheck == false">
                                        <span> El vehiculo esta en corralón: </span>
                                        <v-radio-group v-model="vehiculoCorralon" row>
                                            <v-radio label="SI" :value="true"></v-radio>
                                        </v-radio-group>
                                    </div>
                                </v-col>

                                <v-col cols="12" md="12">
                                    <span> Motivo no liberación: </span>
                                    <v-select filled :items="motivoNoLibItems" v-model="motivoNoLibSelected"
                                        item-text="text" item-value="id" placeholder="Falta Documentación"
                                        :rules="motivoNoLibRules"></v-select>
                                </v-col>
                            </v-row>
                        </v-form>
                        <!-- TODO: HERE GOES THE TEXT-->
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="saveLibVehRobo()">Guardar</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";
import reporteMovimientos from "@/services/Movimientos/Movimientos.service.js";
import checkBoxesCard from "@/components/pages/Shared/components/checkBoxesCard.vue";
import tramitesButtons from "@/components/pages/Shared/components/tramites-buttons.vue";
import Movimientos from "@/components/pages/General/Movimientos/VerMovimientos.vue";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import generalServices from "@/services/ReporteGeneral/ReporteGeneral.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    components: { checkBoxesCard, tramitesButtons, Movimientos },
    data() {
        return {
            loaded: false,
            checkbox: false,
            validForm: true,
            isRobo: false,
            reporteInfo: null,
            reporteInfoArray: [],

            libVehDialog: false,
            efirma: "",
            disposicionAutoridadCheck: null,
            vehiculoCorralon: true,
            motivoNoLibItems: [],
            motivoNoLibSelected: "",

            efirmaRules: [(v) => !!v || "Campo requerido"],
            disposicionAutoridadRules: [(v) => v != null || "Campo requerido"],
            motivoNoLibRules: [(v) => !!v || "Campo requerido"],

            eFirmaErrormessage: "",

            initialDataArray: [],
            mainResponseArray: [],
            extraDataResponseArray: [],

            denunciaQuerellaInfo: [],
            extraDataDenunicaInfo: [],
            subTitlesDataDenuncia: [],

            judicializacionInfo: [],
            extraJudicializacionInfo: [],
            subTitlesDataJudicial: [],

            mostrarLibFisica: [],
            editarLibFisica: null,

            tramitesOptions: [],
            setLoading: 0,

            finalCanInsertMoves: [],

            valorDispocision: null,

            volanteJuridico: false,
            canInsertMoves: true,
            canInserOnlyQuerrella: false,

            checkFist: true,
            checkSecond: false,
            disabledcheckdos: false,

            esPrestacionEspe: false,
            user: '',
            valmultiResp: true,
        };
    },
    async mounted() {
        this.changeReporteMenuOption('Movimiento'); // NoView
        let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        datos.urlname = this.$route.name;
        await MetodosGenerales.guardarEnSesionInfoReporte(datos, "reporte");
        this.reporteInfo = datos;
        this.reporteAiclave = datos.aiclave;
        await this.getInitialDataValidations();
        await this.ObtenerMovimientosGeneralInitalData();
        this.user = MetodosGenerales.ObtenerUserName()

        this.ObtenerTramitesOptions();

        //this.ObtenerCatalogoApartado1();
        //this.ObtenerCatalogoApartado2();
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        reload(val) {
            this.$emit("ReloadEncabezado");
        },
        async showDisposicionValider(item) {
            let response = false;
            let responseComprobar = await reporteMovimientos.MovimientosReporteComprobarPrestacion(this.reporteInfo);
            let esPrestacionEspecial = responseComprobar[0].esEspecial
            if (esPrestacionEspecial != 1) {
                if (this.reporteInfo.aiclave == 23) {
                    response = false;
                } else {
                    if (item.asparte == 1) {
                        response = true;
                    } else {
                        response = false;
                    }
                }
            }
            return response;
        },

        resetForm() {
            this.$refs.form.reset();
            this.eFirmaErrormessage = "";
            this.vehiculoCorralon = true;
        },
        async getInitialDataValidations() {
            let encabezado = await reporteExpJur.EncabezadoReporte(this);
            let permisoQuerella = false;

            // const fhtermino = encabezado.fhtermino;
            // const svresponsable = encabezado.svresponsable.trim();

            // let responsePermiso = await MetodosGenerales.verificarPermisoSolo(
            //     null,
            //     "VerificarPermiso",
            //     "315"
            // );
            // let validaConc = await MetodosGenerales.getReporteEstatus(this);

            let valReporte = await generalServices.obtenerValidacionesReporte(this.reporteInfo);

            let ver = valReporte[0];
            if (ver.estatusReporte == true) {

                this.canInsertMoves = ver.canInsertMoves;
                this.canInserOnlyQuerrella = ver.canOnlyInsertQuerella;
                this.volanteJuridico = ver.volanteJuridico;
                this.permisoQuerella = ver.permisoQuerella;

                let responseComprobar = await reporteMovimientos.MovimientosReporteComprobarPrestacion(this.reporteInfo);
                let esPrestacionEspecial = responseComprobar[0].esEspecial
                if (esPrestacionEspecial.toString() == "1" && this.reporteInfo.aiclave != 27) {
                    this.esPrestacionEspe = true;
                    this.canInserOnlyQuerrella = false;
                }

                if (ver.errorMsj != "") {
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "Alerta",
                        html: ver.errorMsj,
                        showConfirmButton: true,
                        confirmButtonText: "Entendido",
                        allowOutsideClick: false,
                    });
                }

            } else {
                this.canInsertMoves = false;
                this.canInserOnlyQuerrella = false;

                if (ver.errorMsj != "") {
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "Alerta",
                        html: ver.errorMsj,
                        showConfirmButton: true,
                        confirmButtonText: "Entendido",
                        allowOutsideClick: false,
                    });
                }
            }



            // if (validaConc == 2) {
            //     this.canInsertMoves = false;
            //     return;
            // }

            // if (responsePermiso.data.length > 0) {
            //     permisoQuerella = true;
            // }

            // if (svresponsable != "") {
            //     this.volanteJuridico = true;
            // }

            // if (
            //     [23, 24, 27].includes(this.reporteInfo.aiclave) == true &&
            //     svresponsable == "" &&
            //     typeof fhtermino == "string"
            // ) {
            //     this.volanteJuridico = true;
            //     this.canInsertMoves = true;
            // }

            // if (typeof fhtermino == "string" && svresponsable != "") {
            //     this.volanteJuridico = true;
            //     this.canInsertMoves = true;
            // }

            // if (this.reporteInfo.aiclave == 27 && typeof fhtermino == "object") {
            //     this.canInsertMoves = false;
            // }

            // if (this.reporteInfo.aiclave == 24 && typeof fhtermino == "object") {
            //     this.canInsertMoves = false;
            // }

            // if (validaConc == 2) {
            //     this.canInsertMoves = false;
            //     return;
            // }

            // let responseComprobar = await reporteMovimientos.MovimientosReporteComprobarPrestacion(this.reporteInfo);
            // let esPrestacionEspecial = responseComprobar[0].esEspecial
            // if (esPrestacionEspecial.toString() == "1" && this.reporteInfo.aiclave != 27) {
            //     this.esPrestacionEspe = true;
            //     this.canInserOnlyQuerrella = false;
            //     this.canInsertMoves = true;
            //     if (typeof fhtermino == "object") {
            //         this.$swal({
            //             position: "center",
            //             icon: "warning",
            //             title: "Alerta",
            //             html: "No se pueden agregar movimientos si no tiene la fecha de termino capturada",
            //             showConfirmButton: true,
            //             confirmButtonText: "Entendido",
            //             allowOutsideClick: false,
            //         });
            //         return;
            //     }
            // } else {
            //     if (this.reporteInfo.aiclave == 24 && this.canInsertMoves == false) {
            //         this.$swal({
            //             position: "center",
            //             icon: "warning",
            //             title: "Alerta",
            //             html: "No se pueden agregar movimientos si no tiene la fecha de termino capturada",
            //             showConfirmButton: true,
            //             confirmButtonText: "Entendido",
            //             allowOutsideClick: false,
            //         });
            //         return;
            //     }

            //     if (this.reporteInfo.aiclave != 27 && (permisoQuerella == true && typeof fhtermino == "object")) {
            //         this.canInserOnlyQuerrella = true;
            //         this.$swal({
            //             position: "center",
            //             icon: "warning",
            //             title: "Alerta",
            //             html: "Solo podrá ingresar el movimiento de declaración primordial o querella",
            //             showConfirmButton: true,
            //             confirmButtonText: "Entendido",
            //             allowOutsideClick: false,
            //         });
            //         return;
            //     }

            //     if (this.canInsertMoves == false && this.volanteJuridico == false) {
            //         this.$swal({
            //             position: "center",
            //             icon: "warning",
            //             title: "Alerta",
            //             html: "No se pueden agregar movimientos si no tiene Volante Jurídico capturado",
            //             showConfirmButton: true,
            //             confirmButtonText: "Entendido",
            //             allowOutsideClick: false,
            //         });
            //     }
            //     if (this.reporteInfo.aiclave == 27 && this.canInsertMoves == false) {
            //         this.$swal({
            //             position: "center",
            //             icon: "warning",
            //             title: "Alerta",
            //             html: "No se pueden agregar movimientos si no tiene la fecha de termino capturada",
            //             showConfirmButton: true,
            //             confirmButtonText: "Entendido",
            //             allowOutsideClick: false,
            //         });
            //         return;
            //     }
            // }
        },


        async obtenerADispocisionAutoridad() {
            let response = await reporteExpJur.obtenerADispocisionAutoridad(
                this.reporteInfo
            );
            if (
                response[0].ADisposicionAuth == null ||
                response[0].ADisposicionAuth == "" ||
                response[0].ADisposicionAuth == undefined ||
                typeof response[0].ADisposicionAuth != "string"
            ) {
                this.valorDispocision = null;
            } else {
                if (response[0].ADisposicionAuth.trim() == "S") {
                    this.valorDispocision = 1;
                }
                if (response[0].ADisposicionAuth.trim() == "N") {
                    this.valorDispocision = 0;
                }
            }
        },

        async ObtenerMovimientosGeneralInitalData() {
            //TODO: GET HERE ALL THE DYNAMIC DATA THAT NEEDS TO BE RETRIVED
            await this.obtenerADispocisionAutoridad();
            if (this.reporteInfo.aiclave == 24) {
                this.isRobo = true;
                //TODO: change the checkboxes retrive info etc..
                let response = await reporteMovimientos.ObtenerInfoRobo(this);
                let libVeh = response[0].libVehStatus;

                if (libVeh == 1) {
                    this.checkFist = false;
                    this.checkSecond = true;
                } else {
                    this.checkFist = true;
                    this.checkSecond = false;
                }
            }

            //TODO: Check if the prestacion is a "special" one if not continue normally
            let responseComprobar = await reporteMovimientos.MovimientosReporteComprobarPrestacion(this.reporteInfo);
            let esPrestacionEspecial = responseComprobar[0].esEspecial
            let prestacionAsTipo = responseComprobar[0].ptespecial


            if (esPrestacionEspecial.toString() == "1") {
                let initialDataResponse =
                    await reporteMovimientos.MovimientosGeneralObtenerInfoPrestacionEspecial(this.reporteInfo, prestacionAsTipo);
                this.initialDataArray = initialDataResponse;
            } else {
                let initialDataResponse =
                    await reporteMovimientos.MovimientosGeneralObtenerInfoInicial(this);

                this.initialDataArray = initialDataResponse;
            }

            for (let i = 0; i < this.initialDataArray.length; i++) {
                let response = await this.ObtenerCatalogoPorApartado(
                    this.initialDataArray[i].astipo,
                    this.initialDataArray[i].asparte
                );
                this.mainResponseArray[i] = response;
            }
            if (this.reporteInfo.aiclave == 27 && esPrestacionEspecial.toString() != "1") {
                let respuesta = await generalServices.ValidarMultiResp(this.reporteInfo);
                this.valmultiResp = respuesta.val == 1 ? true : false;
            }

            let responseLibFisicaValidacion = await reporteExpJur.validacionLiberacionFisica(this.reporteInfo);

            for (let i = 0; i < this.initialDataArray.length; i++) {
                this.reporteInfoArray[i] = this.reporteInfo;

                this.reporteInfoArray[i].multinsertceclave = this.valmultiResp == true ? this.initialDataArray[i].multinsertceclave : undefined;
                if (this.initialDataArray[i].asid != 14) {
                    this.finalCanInsertMoves[i] = this.canInsertMoves;
                }
                if (this.initialDataArray[i].asid == 14) {
                    if (responseLibFisicaValidacion[0].MostrarLibFis == 1) {
                        this.mostrarLibFisica[i] = true;
                    } else {
                        this.mostrarLibFisica[i] = false;
                    }

                    if (responseLibFisicaValidacion[0].EditarLibFis == 1) {
                        this.canInsertMoves == true
                            ? (this.finalCanInsertMoves[i] = true)
                            : false;
                    }
                }
            }

            for (let i = 0; i < this.initialDataArray.length; i++) {
                let response = await this.ObtenerCatalogoExtraInfoPorApartado(
                    this.initialDataArray[i].astipo,
                    this.initialDataArray[i].asparte
                );
                let cont = 0;

                await response.forEach(async (item) => {
                    if (item.label == "Corralón") {
                        let responseCorralon = await generalServices.ObtenerCorralon(
                            this.reporteInfo
                        );

                        if (responseCorralon[0].show == 1) {

                            let extaInfo = {
                                label: "Corralón",
                                value: responseCorralon[0].prclaveCO,
                                dato:
                                    typeof responseCorralon[0].prnombre == "string"
                                        ? responseCorralon[0].prnombre
                                        : " ",
                                editEstado: 0,
                                notEditable: responseCorralon[0].edit == 1 ? false : true,
                                isCorralon: 1,
                            }
                            response[cont] = extaInfo;
                        }

                    } else if (item.label == "Apoderado Legal") {
                        let extaInfo = {
                            label: "Apoderado Legal",
                            dato: "NO",
                            editEstado: 0,
                            notEditable: true,
                        };
                        let responseApode = await reporteExpJur.validacionLiberacionFisica(
                            this.reporteInfo
                        );
                        if (responseApode[0].somosApoderados == 1) {
                            extaInfo.dato = "SI";
                            extaInfo.iconValue = 0;
                        }
                        response[cont] = extaInfo;
                    } else {
                        response[cont].notEditable = false;
                    }
                    if (item.campo == "Svpartetransito" || item.campo == "Svnumave") {
                        response[cont].columSize = 12;
                    }
                    response[cont].minLength = 6;
                    response[cont].maxLength = 30;

                    cont++;
                });

                this.extraDataResponseArray[i] = response;
            }


            await setTimeout(() => (this.loaded = true), 1000);

            //TODO: GET HERE THE PARTS OF THE FORM THAT NEEDS TO BE SHOWN
        },

        async libVehRobo() {
            let validaConc = await MetodosGenerales.getReporteEstatus(this);
            if (validaConc == 2) {
                this.checkSecond = false;
                this.disabledcheckdos = true;
                return;
            }

            //TODO: OPEN A LOADING ALERT HERE
            let entryTypeResponse = await reporteExpJur.reporteObtenerEditCampoInfo(
                this.reporteInfo,
                1
            );
            var selectItems = await JSON.parse(entryTypeResponse[0].selectItems);
            this.motivoNoLibItems = selectItems;

            this.libVehDialog = true;
        },
        async ObtenerCatalogoPorApartado(tipo, apartado) {
            let response = await reporteMovimientos.ObtenerCatalogoGenerico(
                this.reporteInfo,
                tipo,
                apartado
            );
            return response;
        },

        async saveLibVehRobo() {
            this.$refs.form.validate();
            let valid = this.$refs.form.validate();
            if (valid == true) {
                let eFirmaValidResponse = await reporteMovimientos.ValidarEFirma(
                    this,
                    this.efirma
                );

                if (eFirmaValidResponse.length == 1) {
                    this.$swal({
                        position: "center",
                        title: "Guardando...",
                        html: "Espere un momento por favor",
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                            this.changeLibVehRobo();
                        },
                    });
                } else {
                    this.eFirmaErrormessage = "Firma electrónica incorrecta";
                    return;
                }
            }
        },

        async changeLibVehRobo() {
            let changeResponse = await reporteMovimientos.changeLibVehRobo(
                this,
                this.efirma,
                this.disposicionAutoridadCheck,
                this.motivoNoLibSelected
            );

            this.$swal({
                position: "center",
                icon: "success",
                title: "Exito!",
                html: "El campo se edito correctamente",
                showConfirmButton: false,
                timer: 5000,
            }).then(() => {
                window.location.reload();
            });
        },
        async ObtenerTramitesOptions() {
            let response = await reporteExpJur.ObtenerOpcionesTramites(this.reporteInfo, this.user);
            this.tramitesOptions = response;
            this.setLoading = this.setLoading + 1;
        },
        async ObtenerCatalogoExtraInfoPorApartado(tipo, apartado) {
            let response = await reporteMovimientos.ObtenerCatalogoExtraInfo(
                this,
                tipo,
                apartado
            );
            return response;
        },
    },
};
</script>


<style>
.nopadding-style .vs-collapse-item--header {
    padding: 0px !important;
}

.no-click-event {
    pointer-events: none;
}
</style>

<style scoped>
.classcheck {
    width: 20px !important;
    height: 20px !important;
    min-height: 20px !important;
    min-width: 20px !important;
}

.base-card-container {
    width: 100%;
    height: 100%;
}

.primerAtencion-container {
    background-color: white;
}

.title-card-style {
    padding: 1.5px !important;
}

.text-subtitle {
    font-family: "Poppins", sans-serif;
    font-size: 0.9em;
    color: #7e7e7e;
}

.card-title-text {
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 1em;
    color: white;
}

.label-text {
    font-family: "Roboto", sans-serif;
    font-weight: 700 !important;
    font-size: 12px !important;
}

.label-text2 {
    font-family: "Roboto", sans-serif;
    font-weight: 700 !important;
    font-size: 16px !important;
}

.checkbox-title-text {
    font-family: "Roboto", sans-serif;
    font-weight: 800 !important;
    font-size: 16px !important;
    color: #adb9ff;
}

.buttons-for-checks {
    margin-bottom: 3px !important;
}

.movimiento-style-text {
    font-family: "Roboto", sans-serif;
    font-weight: 600 !important;
    font-size: 14px !important;
}

.checkbox-section-subtitle {
    font-family: "Roboto", sans-serif;
    font-weight: 800 !important;
    font-size: 14px !important;
    color: #004919;
}
</style>
